import { MoreOutlined, RightOutlined } from '@ant-design/icons'
import { Button, Dropdown, Flex, Typography } from 'antd'
import dayjs from 'dayjs'
import React from 'react'
import { useRecoilState } from 'recoil'
import Swal from 'sweetalert2'
import { deleteApproval } from '../../../api/electronicApproval.api'
import { userState } from '../../../store/user'
import '../electricApproval.scss'
const { Text } = Typography
const ApprovalProcess = ({
  proposalList,
  popupMode,
  setPopupMode,
  isChief,
  setSelectedApprovalId,
  setShowDetailPopup,
  refetchApprovalList,
  setSelectedApprovalStatus,
}) => {
  // PENDING,
  // APPROVED,
  // ON_HOLD
  const [user] = useRecoilState(userState)
  const pendingProposalList = proposalList.filter(
    (proposal) => proposal.status === 'PENDING',
  )
  const approvedProposalList = proposalList.filter(
    (proposal) => proposal.status === 'APPROVED',
  )
  const onHoldProposalList = proposalList.filter(
    (proposal) => proposal.status === 'ON_HOLD',
  )

  const draftProposalList = proposalList.filter(
    (proposal) => proposal.status === 'DRAFT' && proposal.createdBy === user.id,
  )

  const handleShowPopup = (proposalId, status, createBy) => {
    const onlyView = !canEdit(createBy) && !isChief
    if (isChief) {
      setPopupMode('MASTER_VIEW')
      return
    } else if (onlyView) {
      setPopupMode('MEMBER_VIEW')
    } else {
      setPopupMode('EDIT')
    }
    setSelectedApprovalId(proposalId)
    setShowDetailPopup(true)
    setSelectedApprovalStatus(status)
    // TODO: 수정 로직 구현
  }

  const handleDelete = async (proposalId) => {
    // console.log('삭제:', proposalId)
    // TODO: 삭제 로직 구현
    try {
      const res = await deleteApproval(proposalId)
      console.log('res::', res)
      Swal.fire({
        customClass: { popup: 'custom-alert' },
        icon: 'success',
        title: '삭제 완료',
        text: '기안서가 삭제되었습니다.',
        confirmButtonText: '확인',
        confirmButtonColor: '#117FFA',
      }).then(() => {
        refetchApprovalList()
      })
    } catch (error) {
      console.log('error::', error)
      // showErrorPopup(error)
      return
    }
  }

  const getMenuItems = (proposalId, status, createBy) => [
    {
      key: 'edit',
      label: '수정',
      onClick: () => handleShowPopup(proposalId, status, createBy),
    },
    {
      key: 'delete',
      label: '삭제',
      onClick: () => handleDelete(proposalId),
    },
  ]
  const getMenuItemsForChief = (proposalId, status, createBy) => [
    {
      key: 'confirm-approval',
      label: '승인 처리',
      onClick: () => handleShowPopup(proposalId, status, createBy),
    },
  ]

  const returnWorkTypeText = (workType) => {
    switch (workType) {
      case 'CORE':
        return '필수 업무'
      case 'IMPROVEMENT':
        return '업무 개선'
    }
  }

  const canEdit = (writerId) => {
    return writerId === user?.id
  }

  return (
    <section className="approval-status-section">
      {/* 승인대기 */}
      <div className="status-column">
        <div className="status-header">
          <Text className="status-title">승인 대기</Text>
          <span className="status-count">{pendingProposalList.length}</span>
        </div>
        <div className="status-items pending-items">
          {pendingProposalList.map((proposal) => (
            <div
              onClick={() =>
                handleShowPopup(
                  proposal.id,
                  proposal.status,
                  proposal.createdBy,
                )
              }
              className="status-item pending-item"
              key={`pending-proposal-${proposal.id}`}
            >
              <div className="item-top">
                <span className="item-tag">
                  {returnWorkTypeText(proposal.workType)}
                </span>
                {canEdit(proposal.createdBy) && (
                  <Dropdown
                    menu={{
                      items: isChief
                        ? getMenuItemsForChief(proposal.id, proposal.status)
                        : getMenuItems(proposal.id, proposal.status),
                    }}
                    trigger={['click']}
                    placement="bottomRight"
                  >
                    <MoreOutlined
                      className="item-menu"
                      onClick={(e) => e.stopPropagation()}
                    />
                  </Dropdown>
                )}
                <div
                  className={`color-chip color-chip-${proposal.workType.toLowerCase()}`}
                />
              </div>
              <Flex align="center" gap={6}>
                <Text className="item-title">{proposal.title}</Text>
                {proposal?.isUrgent && (
                  <div className="item-priority-tag">우선 요청</div>
                )}
              </Flex>
              <Text className="item-desc">{proposal.workGoal}</Text>
              <div className="item-bottom">
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/calandar-check-icon.svg`}
                    alt="calandar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-date">
                    {dayjs(proposal.createdAt).format('YY년 MM월 DD일')}
                  </Text>
                </Flex>
                <div className="item-bottom-divider" />
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/clock-icon.svg`}
                    alt="calendar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-time">
                    {dayjs(proposal.createdAt).format('HH:mm')}
                  </Text>
                </Flex>
              </div>
            </div>
          ))}
          {pendingProposalList?.length === 0 && (
            <Text className="item-desc">승인대기된 기안서가 없습니다.</Text>
          )}
        </div>
      </div>

      {/* 승인완료 */}
      <div className="status-column">
        <div className="status-header">
          <Text className="status-title">승인완료</Text>
          <span className="status-count">{approvedProposalList.length}</span>
        </div>
        <div className="status-items">
          {approvedProposalList?.map((proposal) => (
            <div
              className="status-item yellow-border"
              key={`approved-proposal-${proposal.id}`}
              onClick={() =>
                handleShowPopup(
                  proposal.id,
                  proposal.status,
                  proposal.createdBy,
                )
              }
            >
              <div className="item-top" onClick={() => {}}>
                <span className="item-tag">
                  {returnWorkTypeText(proposal.workType)}
                </span>
                <Button
                  style={{
                    position: 'absolute',
                    right: -20,
                    top: 0,
                    border: 'none',
                  }}
                  type="default"
                  onClick={() => handleShowPopup(proposal.id, proposal.status)}
                >
                  <RightOutlined />
                </Button>
                {/* <Dropdown
                  menu={{
                    items: getMenuItems(proposal.id, proposal.status),
                  }}
                  trigger={['click']}
                  placement="bottomRight"
                >
                  <MoreOutlined
                    className="item-menu"
                    onClick={(e) => e.stopPropagation()}
                  />
                </Dropdown> */}
                <div
                  className={`color-chip color-chip-${proposal.workType.toLowerCase()}`}
                />
              </div>
              <Flex align="center" gap={6}>
                <Text className="item-title">{proposal.title}</Text>
                {proposal?.isUrgent && (
                  <div className="item-priority-tag">우선 요청</div>
                )}
              </Flex>
              <Text className="item-desc">{proposal.workGoal}</Text>
              <div className="item-bottom">
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/calandar-check-icon.svg`}
                    alt="calandar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-date">
                    {dayjs(proposal.createdAt).format('YY년 MM월 DD일')}
                  </Text>
                </Flex>
                <div className="item-bottom-divider" />
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/clock-icon.svg`}
                    alt="calendar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-time">
                    {dayjs(proposal.createdAt).format('HH:mm')}
                  </Text>
                </Flex>
              </div>
            </div>
          ))}
          {approvedProposalList?.length === 0 && (
            <Text className="item-desc">승인완료된 기안서가 없습니다.</Text>
          )}
        </div>
      </div>

      {/* 승인보류 */}
      <div className="status-column">
        <div className="status-header">
          <Text className="status-title">승인보류</Text>
          <span className="status-count">{onHoldProposalList.length}</span>
        </div>
        <div className="status-items">
          {/* 비어있음 */}
          {onHoldProposalList?.map((proposal) => (
            <div
              className="status-item rodls-border"
              key={`on-hold-proposal-${proposal.id}`}
              onClick={() =>
                handleShowPopup(
                  proposal.id,
                  proposal.status,
                  proposal.createdBy,
                )
              }
            >
              <div className="item-top">
                <span className="item-tag">
                  {returnWorkTypeText(proposal.workType)}
                </span>
                <Button
                  style={{
                    position: 'absolute',
                    right: -20,
                    top: 0,
                    border: 'none',
                  }}
                  type="default"
                  onClick={() => handleShowPopup(proposal.id, proposal.status)}
                >
                  <RightOutlined />
                </Button>
                <div className={`color-chip color-chip-hold`} />
              </div>
              <Flex align="center" gap={6}>
                <Text className="item-title">{proposal.title}</Text>
                {proposal?.isUrgent && (
                  <div className="item-priority-tag">우선 요청</div>
                )}
              </Flex>
              <Text className="item-desc">{proposal.workGoal}</Text>
              <div className="item-bottom">
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/calandar-check-icon.svg`}
                    alt="calandar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-date">
                    {dayjs(proposal.createdAt).format('YY년 MM월 DD일')}
                  </Text>
                </Flex>
                <div className="item-bottom-divider" />
                <Flex align="center" gap={2}>
                  <img
                    src={`${process.env.REACT_APP_HOST}/assets/icon/aops/clock-icon.svg`}
                    alt="calendar-check-icon"
                    style={{ width: 16, height: 16 }}
                  />
                  <Text className="item-time">
                    {dayjs(proposal.createdAt).format('HH:mm')}
                  </Text>
                </Flex>
              </div>
            </div>
          ))}
          {onHoldProposalList?.length === 0 && (
            <Text className="item-desc">승인보류된 기안서가 없습니다.</Text>
          )}
        </div>
      </div>
      {!isChief && draftProposalList?.length > 0 && (
        <div className="status-column">
          <div className="status-header">
            <Text className="status-title">임시 저장</Text>
            <span className="status-count">{draftProposalList.length}</span>
          </div>
          <div className="status-items">
            {/* 비어있음 */}
            {draftProposalList?.map((proposal) => (
              <div
                className="status-item rodls-border"
                key={`on-hold-proposal-${proposal.id}`}
                onClick={() =>
                  handleShowPopup(
                    proposal.id,
                    proposal.status,
                    proposal.createdBy,
                  )
                }
              >
                <div className="item-top">
                  <span className="item-tag">
                    {returnWorkTypeText(proposal.workType)}
                  </span>
                  <Button
                    style={{
                      position: 'absolute',
                      right: -20,
                      top: 0,
                      border: 'none',
                    }}
                    type="default"
                    onClick={() =>
                      handleShowPopup(proposal.id, proposal.status)
                    }
                  >
                    <RightOutlined />
                  </Button>
                  <div className={`color-chip color-chip-hold`} />
                </div>
                <Flex align="center" gap={6}>
                  <Text className="item-title">{proposal.title}</Text>
                  {proposal?.isUrgent && (
                    <div className="item-priority-tag">우선 요청</div>
                  )}
                </Flex>
                <Text className="item-desc">{proposal.workGoal}</Text>
                <div className="item-bottom">
                  <Flex align="center" gap={2}>
                    <img
                      src={`${process.env.REACT_APP_HOST}/assets/icon/aops/calandar-check-icon.svg`}
                      alt="calandar-check-icon"
                      style={{ width: 16, height: 16 }}
                    />
                    <Text className="item-date">
                      {dayjs(proposal.createdAt).format('YY년 MM월 DD일')}
                    </Text>
                  </Flex>
                  <div className="item-bottom-divider" />
                  <Flex align="center" gap={2}>
                    <img
                      src={`${process.env.REACT_APP_HOST}/assets/icon/aops/clock-icon.svg`}
                      alt="calendar-check-icon"
                      style={{ width: 16, height: 16 }}
                    />
                    <Text className="item-time">
                      {dayjs(proposal.createdAt).format('HH:mm')}
                    </Text>
                  </Flex>
                </div>
              </div>
            ))}
            {draftProposalList?.length === 0 && (
              <Text className="item-desc"> 임시 저장된 기안서가 없습니다.</Text>
            )}
          </div>
        </div>
      )}
    </section>
  )
}

export default ApprovalProcess
